import React from 'react'

import { SearchkitComponent, SortingAccessor } from 'searchkit'

class SortingSelector extends SearchkitComponent {
    accessor = null
    order = 'asc'

    constructor(props) {
        super(props)
        const options = props.options
        this.state = {
            options,
            order: 'asc',
        }
    }

    defineAccessor() {
        const options = []
        this.state.options.forEach(o => {
            options.push({ ...o, order: 'asc' })
            options.push({ ...o, order: 'desc' })
        })
        return new SortingAccessor('sort', { options })
    }

    toggleItem(key) {
        const selected = this.accessor.getSelectedOption()
        if (selected.field === key.field) {
            this.order = this.order === 'asc' ? 'desc' : 'asc'
        } else {
            this.order = 'desc'
        }

        this.accessor.state = this.accessor.state.setValue(
            `${key.field}_${this.order}`,
        )
        this.searchkit.performSearch()
    }

    setItems(keys) {
        this.toggleItem(keys[0])
    }

    render() {
        if (this.isInitialLoading()) return null

        const selected = this.accessor.getSelectedOption()

        return (
            <tr className="thead-main">
                {this.state.options.map(o =>
                    <th
                        key={o.field}
                        style={{ cursor: 'pointer' }}
                        className={o.className}
                        onClick={() => this.toggleItem(o)}
                    >
                        {o.label}
                        {o.field === selected.field
                            ? <i
                                  className={`fa fa-caret-${selected.order ===
                                  'asc'
                                      ? 'up'
                                      : 'down'}`}
                              />
                            : ''}
                    </th>,
                )}
            </tr>
        )
    }
}

export default SortingSelector
